import React, { Component } from 'react';
import { connect } from 'react-redux';

import routeDetails from 'app/constants/routeDetails';

import questions from 'app/locales/questions';

import { Actions as NavigationActions } from 'app/redux/navigation/actions';

import Button, { buttonThemes } from 'app/components/Button';
import AnswerGroup from 'app/components/AnswerGroup';

import styles from './styles.css';

class Question extends Component {
  getSelectedAnswersCount = () => {
    const { selectedAnswers } = this.props;

    return Object.keys(selectedAnswers).length;
  };

  render() {
    const {
      data: { answers, id, question },
      dispatchNavigateToQuestions,
      handleOnAnswerClick,
      isLastQuestion,
      questionCount,
      selectedAnswers,
    } = this.props;

    const isButtonActive =
      isLastQuestion && this.getSelectedAnswersCount() === questionCount;

    return (
      <div className={styles.container}>
        <h3 className={styles.question}>{question}</h3>
        <div className={styles.answerContainer}>
          <AnswerGroup
            answers={answers}
            handleOnAnswerClick={handleOnAnswerClick}
            isLastQuestion={isLastQuestion}
            questionId={id}
            selectedAnswers={selectedAnswers}
          />
        </div>
        <div className={styles.bottomContainer}>
          {isLastQuestion ? (
            <Button
              isDisabled={!isButtonActive}
              label={'Get results'}
              onClick={dispatchNavigateToQuestions}
              passedStyles={styles.button}
              theme={buttonThemes.LIGHT}
            />
          ) : (
            <h4 className={styles.tag}>{questions.tag}</h4>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchNavigateToQuestions: () =>
    dispatch(NavigationActions.navigateTo(routeDetails.RESULTS.url)),
});

export default connect(
  null,
  mapDispatchToProps
)(Question);



// WEBPACK FOOTER //
// ./src/components/Question/index.js